import { isEmpty } from "lodash";

import {
  AudienceFiltersDto,
  ExperiencePageTargetingFe,
  ExpressionNodeQueryType,
} from "@intelligems/ig-types";

import { VariationFe } from "../../../types/schemas/variations";

import { containsQueryParam } from "./utils";

export const isJavaScriptExpressionValid = (input) => {
  try {
    // Try to evaluate the input as JavaScript code
    eval(input);
    return { isValid: true, errorMessage: null }; // Valid JavaScript expression
  } catch (error: any) {
    return { isValid: false, errorMessage: error.message }; // Not a valid JavaScript expression
  }
};

export const isUrlValid = (
  value: string,
  domain: string,
  validateValue?: boolean
) => {
  if (validateValue) {
    try {
      const domainUrl = new URL(value);
      if (value && !value?.includes(domainUrl.host.replace("www.", ""))) {
        return { isValid: false, errorMessage: "Invalid Subdomain URL" };
      } else {
        return { isValid: true, errorMessage: null };
      }
    } catch (e) {
      return { isValid: false, errorMessage: "Invalid URL" };
    }
  } else {
    try {
      const domainUrl = new URL(domain);
      if (value && !value?.includes(domainUrl.host.replace("www.", ""))) {
        return { isValid: false, errorMessage: "Invalid Subdomain URL" };
      } else {
        return { isValid: true, errorMessage: null };
      }
    } catch (e) {
      return { isValid: false, errorMessage: "Invalid Subdomain URL" };
    }
  }
};

export const isPageTargetNotValid = (target: ExperiencePageTargetingFe) => {
  if (target.filterType !== "jsExpression" && containsQueryParam(target.value))
    return true;
  else if (
    target.filter === "contains" ||
    target.filter === "startsWith" ||
    target.filter === "endsWith" ||
    target.filter === "doesNotContain" ||
    target.filterType === "jsExpression"
  ) {
    return (
      !!(isEmpty(target.value) || isEmpty(target.filter)) ||
      target.value === "/" ||
      (target.filterType === "jsExpression" &&
        !isJavaScriptExpressionValid(target.value).isValid)
    );
  } else return !!isEmpty(target.filter);
};

export const isQueryParamNotValid = (
  entity: "experiment" | "campaign",
  filter: AudienceFiltersDto,
  variations: VariationFe[]
) => {
  if (
    isEmpty(filter!.expression![0]!.query?.key) ||
    isEmpty(filter!.expression![0]!.query?.filter) ||
    isEmpty(filter!.expression![0]!.query?.value) ||
    isEmpty(filter.action)
  ) {
    return true;
  }
  if (
    entity === "experiment" &&
    filter.action === "assignVariation" &&
    (isEmpty(filter.variationId) ||
      (filter.variationId &&
        !variations.map((group) => group.id).includes(filter.variationId)))
  ) {
    return true;
  }
  return false;
};
